module.exports = __webpack_public_path__ + "img/jiuzhou-user-ios.b555d2bf.png";